import type { ComponentType } from "react";
import { Navigate } from "infrastructure/router";
import { RoleName } from "consts/auth";
import { WebRoutes } from "consts/enpoints/web";
import useUser from "features/auth/useUser";
import { withApplication } from "features/ecommerce/helpers";
import When from "ui/support/When";

export const withRedirect = <TProps extends object>(
    Component: ComponentType<TProps>,
    redirectStrategy = new Map([
        [RoleName.OnboardingE, withApplication(WebRoutes.Onboarding.Merchant)],
        [RoleName.OnboardingO, withApplication(WebRoutes.Onboarding.HighRiskMerchant)]
    ])
) =>
    (props: TProps) => {
        const { user, getRoleName } = useUser();

        const redirectPath = redirectStrategy.get(getRoleName())?.(user);

        return (
            <When
                if={Boolean(redirectPath)}
                then={() => (
                    <Navigate
                        replace
                        to={redirectPath}
                    />
                )}
                else={() => (
                    <Component
                        {...props}
                    />
                )}
            />
        );
    };

export default withRedirect;
